import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import NavBar from '../../../../component/b2c/navBar/navBar';
import { useMyContext } from '../../../../context/MyContext';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';
import '../../../../css/custom-scrollbar.css';
import { IoClose } from "react-icons/io5";
import { Base_Url, payment, walletRecharge, grandTotalAmount, updatewalletAmount, amountUpdate } from '../../../../config/config';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Loader from '../../../../component/spinner/spinner';
import { X, CreditCard, User, ArrowUp, CheckCircle, Wallet, Truck, History, Settings } from 'lucide-react';

const WalletRecharge = () => {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const role = localStorage.getItem('role');
  const [loader, setLoader] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [paymentUrl, setPaymentUrl] = useState('');
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const location = useLocation();
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentBalanace, setCurrentBalanace] = useState(0);

  const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
  const [updateData, setUpdateData] = useState({
    txn_id: '',
    user_id: '',
    amount: '',
    type: 'add'
  });
  const [updateLoader, setUpdateLoader] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.status === "paid") {
        setTimeout(() => {
          window.location.href = "";
          setPaymentUrl('');
        }, 3000);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (role === "admin") {
      getTotalAmount();
    }
    getPayment();
  }, []);

  const getTotalAmount = async () => {
    const uri = Base_Url + "admin/" + grandTotalAmount;
    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        setTotalAmount(data.grand_total);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const getPayment = async () => {
    const url = Base_Url + payment
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setCurrentBalanace(data.totalamount);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleRecharge = async (e) => {
    e.preventDefault();

    if (!amount || isNaN(amount)) {
      toast.error('Please enter a valid amount');
      return;
    }

    const serviceCharge = (amount * 0.025).toFixed(2);
    const gst = (serviceCharge * 0.18).toFixed(2);
    const totalAmount = (parseFloat(amount) - parseFloat(serviceCharge) - parseFloat(gst)).toFixed(2);
    const maxDiscount = 5000;
    const creditCardDiscountText = parseFloat(amount) <= maxDiscount
      ? `Recharge ₹5,000 or more and get 5% cashback — up to ₹250! `
      : '';

    const result = await Swal.fire({
      title: '<span style="color: #1f2937; font-weight: 600;">Wallet Recharge</span>',
      html: `
        <div style="text-align: left; padding: 10px; border-radius: 8px; background-color: #f8f9fa;">
          <div style="display: flex; justify-content: center; margin-bottom: 15px;">
            <div style="background-color: #1f2937; color: white; border-radius: 50%; width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; font-size: 24px;">
              <i class="fas fa-wallet"></i>
            </div>
          </div>
          
          <div style="margin-bottom: 15px; padding: 15px; border-radius: 8px; background-color: white; box-shadow: 0 2px 5px rgba(0,0,0,0.08);">
            <p style="font-size: 16px; margin-bottom: 10px;">Recharge Amount: <span style="float: right; font-weight: 600; color: #1f2937;">₹${amount}</span></p>
            <p style="font-size: 14px; color: #666; margin-bottom: 5px;">Service charge (2.5%): <span style="float: right;">₹${serviceCharge}</span></p>
            <p style="font-size: 14px; color: #666; margin-bottom: 5px;">GST (18%): <span style="float: right;">₹${gst}</span></p>
            <hr style="border-top: 1px dashed #ddd; margin: 10px 0;">
            <p style="font-size: 16px; margin: 0; font-weight: 600;">Total to Wallet: <span style="float: right; color: #1f2937;">₹${totalAmount}</span></p>
          </div>
          
          <div style="background-color: #e3f2fd; padding: 12px; border-radius: 8px; border-left: 4px solid #2196f3; margin-bottom: 10px;">
            <p style="margin: 0; color: #0d47a1; display: flex; align-items: center;">
              <i class="fas fa-credit-card" style="margin-right: 8px;"></i>
              <span style="font-weight: 500;">${creditCardDiscountText}</span>
            </p>
          </div>
          
          <div style="background-color: #fff3e0; padding: 10px; border-radius: 8px; border-left: 4px solid #ff9800;">
            <p style="margin: 0; color: #e65100; font-size: 13px; display: flex; align-items: center;">
              <i class="fas fa-exclamation-circle" style="margin-right: 8px;"></i>
              <span>Additional charges may apply when using a credit card.</span>
            </p>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: '<i class="fas fa-check-circle"></i> Proceed',
      cancelButtonText: '<i class="fas fa-times-circle"></i> Cancel',
      confirmButtonColor: '#1f2937',
      cancelButtonColor: '#6b7280',
      buttonsStyling: true,
    });

    if (result.isConfirmed) {
      try {
        setLoader(true);
        const uri = Base_Url + walletRecharge;
        const response = await axios.post(
          uri,
          { amount },
          {
            headers: {
              token: token,
              cus_id: cus_id,
              "Content-Type": "application/json"
            },
          }
        );

        if (response.data.status === "SUCCESS") {
          const url = response.data?.data?.link;
          setPaymentUrl(url);
          setAmount('');
          setCoupon('');
          setLoader(false);
        } else {
          toast.error(response.data.message || 'Recharge failed');
          setLoader(false);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'An error occurred');
        setLoader(false);
      }
    }
  };

  const handleOpenUpdatePopup = () => {
    setIsUpdatePopupOpen(true);
    setUpdateData(prevState => ({
      ...prevState,
    }));
  };

  const handleCloseUpdatePopup = () => {
    setIsUpdatePopupOpen(false);
    setUpdateData({
      txn_id: '',
      user_id: '',
      amount: '',
      type: 'add'
    });
  };

  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData({
      ...updateData,
      [name]: value
    });
  };

  const handleUpdateWallet = async (e) => {
    e.preventDefault();

    if (!updateData.txn_id.trim()) {
      toast.error('Transaction ID is required');
      return;
    }

    if (!updateData.user_id.trim()) {
      toast.error('Customer ID is required');
      return;
    }

    try {
      setUpdateLoader(true);
      const uri = Base_Url + amountUpdate;

      const response = await axios.post(
        uri,
        updateData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json"
          },
        }
      );

      if (response.data && response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        handleCloseUpdatePopup();
        getPayment();
      } else {
        toast.error(
          response.data?.message ||
          response.data?.messsge ||
          response.data?.messages?.error ||
          'Failed to update wallet'
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.messsge ||
        error.response?.data?.messages?.error ||
        'An error occurred'
      )
    } finally {
      setUpdateLoader(false);
    }
  };

  const viewHistory = () => {
    navigate('/payments/topuphistory');
  };

  const viewShipmentCharges = () => {
    navigate('/payments/shippingCharges');
  };

  const handleAmountChange = (e) => {
    const val = e.target.value;

    if (val > 50000) {
      toast.error("Amount cannot exceed ₹50,000");
      setError("Amount cannot exceed ₹50,000");
    } else {
      setError('');
      setAmount(val);
    }
  };
  const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-white'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

            <NavBar />
            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                        <Sidebar />
                    </div>
                )}

        <div className={`flex-1 p-3 overflow-hidden transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-200'}`}>
          <div className=" h-full grid grid-cols-1 lg:grid-cols-5 gap-3">

            {/* Main Content Section */}
            <div className={`lg:col-span-3 backdrop-blur-lg border shadow-sm rounded-2xl p-4 relative overflow-hidden h-fit transition-colors duration-300 ${
              isDarkMode 
                ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 shadow-[0_0_30px_rgba(0,0,0,0.4)]' 
                : 'bg-white border-gray-200'
            }`}>

              {/* Header */}
              <div className={`flex items-center justify-center gap-2 mb-4 relative z-10 rounded-xl py-2 px-4 shadow-sm transition-colors duration-300 ${
                isDarkMode 
                  ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600' 
                  : 'bg-[#2C5EAD]'
              }`}>
                <FaCcVisa className="text-white" size={16} />
                <FaCcMastercard className="text-white" size={16} />
                <span className="text-white font-bold text-xs tracking-wide">Wallet Recharge</span>
              </div>

              {paymentUrl && (
                <div className="fixed inset-0 z-50 bg-white">
                  <iframe
                    src={paymentUrl}
                    width="100%"
                    height="100%"
                    className="border-none"
                  />
                </div>
              )}

              {/* Current Balance Card */}
              <div className="mb-3 relative z-10">
                <div className={`p-3 w-full rounded-xl text-center border transition-colors duration-300 ${
                  isDarkMode 
                    ? 'border-indigo-500/30 bg-gradient-to-br from-[#1F2937] to-[#111827] shadow-[0_0_20px_rgba(99,102,241,0.1)]' 
                    : 'border-gray-200 bg-gray-50'
                }`}>
                  <div className="flex items-center justify-center gap-1.5 mb-1">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center transition-colors duration-300 ${
                      isDarkMode 
                        ? 'bg-gradient-to-br from-indigo-500 to-purple-600' 
                        : 'bg-[#2C5EAD]'
                    }`}>
                      <span className="text-white font-bold text-[10px]">₹</span>
                    </div>
                    <h3 className={`text-[10px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-indigo-300' : 'text-gray-500'}`}>Current Balance</h3>
                  </div>
                  <p className={`text-2xl font-black ${isDarkMode ? 'text-white' : 'text-black'}`}>
                    ₹{currentBalanace}
                  </p>
                </div>
              </div>

              {/* Admin Update Button */}
              {role === "admin" && (
                <div className="mb-3 relative z-10">
                  <Button
                    onClick={handleOpenUpdatePopup}
                    variant="contained"
                    fullWidth
                    startIcon={<Settings size={14} />}
                    sx={{
                      background: isDarkMode ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' : '#2C5EAD',
                      color: 'white',
                      textTransform: 'capitalize',
                      borderRadius: '10px',
                      padding: '6px 14px',
                      fontSize: '10px',
                      fontWeight: 600,
                      boxShadow: isDarkMode ? '0 0 15px rgba(99,102,241,0.3)' : '0 2px 8px rgba(0,0,0,0.15)',
                      '&:hover': {
                        background: isDarkMode ? 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' : '#2C5EAD',
                        boxShadow: isDarkMode ? '0 0 25px rgba(99,102,241,0.5)' : '0 2px 8px rgba(0,0,0,0.15)',
                      },
                    }}
                  >
                    Update Wallet Balance
                  </Button>
                </div>
              )}

              {/* Action Buttons */}
              <div className="grid grid-cols-2 gap-2 mb-4 relative z-10">
                <Button
                  onClick={viewShipmentCharges}
                  variant="outlined"
                  startIcon={<Truck size={12} />}
                  sx={{
                    borderColor: isDarkMode ? 'rgba(99,102,241,0.4)' : '#9ca3af',
                    color: isDarkMode ? '#a5b4fc' : '#374151',
                    textTransform: 'capitalize',
                    borderRadius: '10px',
                    padding: '5px 8px',
                    fontSize: '10px',
                    fontWeight: 600,
                    '&:hover': {
                      borderColor: isDarkMode ? '#6366f1' : '#1f2937',
                      background: isDarkMode ? 'rgba(99,102,241,0.1)' : 'rgba(0,0,0,0.04)',
                      boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.3)' : 'none',
                    },
                  }}
                >
                  Shipment Charges
                </Button>

                <Button
                  onClick={viewHistory}
                  variant="outlined"
                  startIcon={<History size={12} />}
                  sx={{
                    borderColor: isDarkMode ? 'rgba(99,102,241,0.4)' : '#9ca3af',
                    color: isDarkMode ? '#a5b4fc' : '#374151',
                    textTransform: 'capitalize',
                    borderRadius: '10px',
                    padding: '5px 8px',
                    fontSize: '10px',
                    fontWeight: 600,
                    '&:hover': {
                      borderColor: isDarkMode ? '#6366f1' : '#1f2937',
                      background: isDarkMode ? 'rgba(99,102,241,0.1)' : 'rgba(0,0,0,0.04)',
                      boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.3)' : 'none',
                    },
                  }}
                >
                  Topup History
                </Button>
              </div>

              {/* Recharge Form */}
              <form onSubmit={handleRecharge} className="space-y-2.5 relative z-10">
                <div className="space-y-2.5">
                  <div>
                    <label htmlFor="amount" className={`block text-[10px] font-semibold mb-1 flex items-center gap-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-black'}`}></span>
                      Custom Amount
                    </label>
                    <div className="relative">
                      <span className={`absolute left-3 top-1/2 -translate-y-1/2 font-bold text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>₹</span>
                      <input
                        type="number"
                        id="amount"
                        value={amount}
                        onChange={handleAmountChange}
                        placeholder="Enter amount"
                        className={`w-full pl-8 pr-3 py-2 border text-sm rounded-lg transition-all duration-200 font-medium ${
                          error
                            ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20'
                            : isDarkMode
                              ? 'bg-[#1F2937] border-gray-700 text-white focus:border-indigo-500 focus:ring-indigo-500/20'
                              : 'border-gray-200 focus:border-gray-400 focus:ring-gray-400/20 bg-white'
                        }`}
                        required
                      />
                    </div>
                    {error && <p className="text-[9px] text-red-500 mt-0.5">{error}</p>}
                  </div>

                  <div>
                    <label htmlFor="coupon" className={`block text-[10px] font-semibold mb-1 flex items-center gap-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${isDarkMode ? 'bg-gray-500' : 'bg-gray-500'}`}></span>
                      Apply Coupon <span className={`text-[9px] font-normal ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>(optional)</span>
                    </label>
                    <div className="relative">
                      <span className={`absolute left-3 top-1/2 -translate-y-1/2 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>🎫</span>
                      <input
                        type="text"
                        id="coupon"
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                        placeholder="Enter coupon code"
                        className={`w-full pl-9 pr-3 py-2 border text-sm rounded-lg transition-all duration-200 font-medium ${
                          isDarkMode
                            ? 'bg-[#1F2937] border-gray-700 text-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20'
                            : 'border-gray-200 focus:border-gray-400 focus:ring-2 focus:ring-gray-400/20 bg-white'
                        }`}
                      />
                    </div>
                  </div>
                </div>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    background: isDarkMode ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' : '#2C5EAD',
                    color: 'white',
                    textTransform: 'capitalize',
                    borderRadius: '12px',
                    padding: '8px 16px',
                    fontSize: '12px',
                    fontWeight: 700,
                    boxShadow: isDarkMode ? '0 0 20px rgba(99,102,241,0.4)' : '0 4px 16px rgba(0,0,0,0.2)',
                    '&:hover': {
                      background: isDarkMode ? 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' : '#2C5EAD',
                      boxShadow: isDarkMode ? '0 0 30px rgba(99,102,241,0.6)' : '0 4px 16px rgba(0,0,0,0.2)',
                    },
                  }}
                >
                  {loader ? (
                    <div className="flex items-center justify-center gap-2">
                      <Loader />
                      <span>Processing...</span>
                    </div>
                  ) : (
                    <span className="flex items-center justify-center gap-2">
                      <Wallet size={13} />
                      Recharge Now
                    </span>
                  )}
                </Button>
              </form>

              {/* Update Wallet Popup */}
              {isUpdatePopupOpen && (
                <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                  <div className={`rounded-2xl max-w-sm w-full shadow-2xl relative overflow-hidden transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-[#111827] border border-gray-800 shadow-[0_0_50px_rgba(0,0,0,0.8)]' 
                      : 'bg-white border-gray-200'
                  }`}>

                    <div className={`flex p-2 justify-between items-center relative z-10 transition-colors duration-300 ${
                      isDarkMode 
                        ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600' 
                        : 'bg-blue-600'
                    }`}>
                      <h2 className="text-sm font-bold text-white">
                        Update Wallet Balance
                      </h2>
                      <button
                        onClick={handleCloseUpdatePopup}
                        className="text-white/80 hover:text-white transition-colors duration-200 rounded-full p-1 hover:bg-white/10"
                      >
                        <X size={18} />
                      </button>
                    </div>

                    <div className="space-y-2.5 relative p-4 z-10">
                      <div>
                        <label className={`block text-[10px] font-semibold mb-1 flex items-center gap-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                          <CreditCard size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                          Transaction ID
                        </label>
                        <input
                          type="text"
                          name="txn_id"
                          value={updateData.txn_id}
                          onChange={handleUpdateInputChange}
                          placeholder="Enter transaction ID"
                          className={`w-full p-2 text-sm border-2 rounded-lg transition-all duration-200 font-medium ${
                            isDarkMode
                              ? 'bg-[#1F2937] border-gray-700 text-white focus:ring-1 focus:ring-indigo-500/40 focus:border-indigo-500'
                              : 'border-gray-200 focus:ring-1 focus:ring-gray-400/20 focus:border-gray-400 bg-white'
                          }`}
                          required
                        />
                      </div>

                      <div>
                        <label className={`block text-[10px] font-semibold mb-1 flex items-center gap-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                          <CreditCard size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                          Amount
                        </label>
                        <input
                          type="number"
                          name="amount"
                          min="0"
                          step="1"
                          value={updateData.amount}
                          onChange={handleUpdateInputChange}
                          placeholder="Enter Amount"
                          className={`w-full p-2 text-sm border-2 rounded-lg transition-all duration-200 font-medium ${
                            isDarkMode
                              ? 'bg-[#1F2937] border-gray-700 text-white focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500'
                              : 'border-gray-200 focus:ring-2 focus:ring-gray-400/20 focus:border-gray-400 bg-white'
                          }`}
                          required
                        />
                      </div>

                      <div>
                        <label className={`block text-[10px] font-semibold mb-1 flex items-center gap-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                          <User size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                          Customer ID
                        </label>
                        <input
                          type="number"
                          name="user_id"
                          value={updateData.user_id}
                          onChange={handleUpdateInputChange}
                          min="0"
                          step="1"
                          placeholder="Enter customer ID"
                          className={`w-full p-2 text-sm border-2 rounded-lg transition-all duration-200 font-medium ${
                            isDarkMode
                              ? 'bg-[#1F2937] border-gray-700 text-white focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500'
                              : 'border-gray-200 focus:ring-2 focus:ring-gray-400/20 focus:border-gray-400 bg-white'
                          }`}
                          required
                        />
                      </div>

                      <div>
                        <label className={`block text-[10px] font-semibold mb-1 flex items-center gap-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                          <ArrowUp size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                          Type
                        </label>
                        <div className="relative">
                          <select
                            name="type"
                            value={updateData.type}
                            onChange={handleUpdateInputChange}
                            className={`w-full p-2 text-sm border-2 rounded-lg appearance-none font-medium transition-colors duration-300 ${
                              isDarkMode
                                ? 'bg-[#1F2937] border-gray-700 text-white'
                                : 'bg-white border-gray-200'
                            }`}
                          >
                            <option value="add">Add</option>
                            <option value="deduct">Deduct</option>
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center px-2.5 pointer-events-none">
                            <svg className={`h-4 w-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div className={`flex justify-end gap-2 mt-3 pt-3 border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-200'}`}>
                        <button
                          type="button"
                          onClick={handleCloseUpdatePopup}
                          className={`px-4 py-1.5 text-[10px] font-semibold rounded-lg transition-all duration-200 ${
                            isDarkMode
                              ? 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                              : 'bg-gray-200 text-gray-600 hover:bg-gray-200'
                          }`}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={handleUpdateWallet}
                          className={`px-4 py-1.5 text-[10px] font-semibold text-white rounded-lg transition-all duration-200 flex items-center justify-center min-w-[80px] ${
                            isDarkMode
                              ? 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:shadow-[0_0_15px_rgba(99,102,241,0.5)]'
                              : 'bg-blue-600 hover:bg-gray-800'
                          }`}
                        >
                          {updateLoader ? (
                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          ) : (
                            <span className="flex items-center gap-1.5">
                              <CheckCircle size={13} />
                              Submit
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Terms & Conditions Section */}
            <div className={`lg:col-span-2 backdrop-blur-lg border shadow-sm rounded-2xl p-4 relative h-full overflow-y-auto custom-scrollbar transition-colors duration-300 ${
              isDarkMode 
                ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 shadow-[0_0_30px_rgba(0,0,0,0.4)]' 
                : 'bg-white border-gray-200'
            }`}>

              <div className="relative z-10">
                <div className="flex items-center gap-2 mb-3">
                  <div className={`w-1 h-5 rounded-full ${isDarkMode ? 'bg-gradient-to-b from-rose-500 to-pink-600' : 'bg-red-600'}`}></div>
                  <h1 className={`font-extrabold text-[12px] uppercase tracking-wide ${isDarkMode ? 'text-rose-400' : 'text-red-600'}`}>
                    Terms & Conditions for Wallet Top-Up
                  </h1>
                </div>

                <div className={`border-l-4 p-2.5 rounded-r-lg mb-3 transition-colors duration-300 ${
                  isDarkMode 
                    ? 'border-rose-500 bg-rose-500/5' 
                    : 'border-red-600 bg-gray-50'
                }`}>
                  <p className={`font-medium text-[10px] leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                    These Terms & Conditions ("T&Cs") govern the top-up of funds
                    ("Top-Up") into your wallet account ("Wallet") on PICKUPXPRESS. By
                    topping up your Wallet, you agree to these T&Cs.
                  </p>
                </div>

                <div className="space-y-2.5">
                  {[
                    {
                      title: "1. Eligibility",
                      content: "* You must be a registered user of the PICKUPXPRESS to top up your Wallet.\n* You must comply with all applicable laws and regulations when topping up your Wallet."
                    },
                    {
                      title: "2. Top-Up Process",
                      content: "* To add funds to your Wallet, you may use the available payment methods supported by the PICKUPXPRESS, including credit/debit cards, bank transfers, Wallet/UPI.\n* All Top-Up transactions are final and cannot be reversed or refunded unless required by law or expressly stated in these T&Cs.\n* The minimum and maximum amounts for a Top-Up are subject to limits as determined by the Platform from time to time."
                    },
                    {
                      title: "3. Processing of Funds",
                      content: "* Funds topped up into your Wallet will show in your balance within 0-36 hours depending on the payment method used.\n* The Platform is not responsible for delays caused by the payment processing service or other third parties.\n* The Wallet balance is non-transferable and can only be used for services on the PICKUPXPRESS platform."
                    },
                    {
                      title: "4. Fees and Charges",
                      content: "* The Platform may charge fees for Top-Up transactions, which will be disclosed at the time of the transaction.\n* Any applicable fees or taxes, including foreign exchange fees for cross-border transactions, will be borne by the user."
                    },
                    {
                      title: "5. Usage of Wallet Funds",
                      content: "* Funds in your Wallet can only be used for transactions within the PICKUPXPRESS.\n* Wallet funds cannot be withdrawn, transferred, or redeemed for cash, except where required by law or as specified by the PICKUPXPRESS."
                    },
                    {
                      title: "6. Account Security",
                      content: "* You are responsible for maintaining the security of your account and ensuring that your login credentials are not shared with others.\n* The Platform is not liable for any unauthorized access to your account or Wallet due to your negligence."
                    },
                    {
                      title: "7. Expiration and Forfeiture of Funds",
                      content: "* Wallet balances may expire or be subject to forfeiture after a specified period of inactivity as determined by the PICKUPXPRESS policies.\n* The Platform will provide reasonable notice before any such expiration or forfeiture of funds."
                    },
                    {
                      title: "8. Fraud Prevention",
                      content: "* The PICKUPXPRESS reserves the right to suspend or terminate your account and Wallet, and to investigate any Top-Up transaction suspected of being fraudulent or in violation of these T&Cs.\n* Any attempt to defraud the PICKUPXPRESS or misuse the Wallet will result in legal action and forfeiture of funds."
                    },
                    {
                      title: "9. Changes to Terms & Conditions",
                      content: "* The Platform reserves the right to modify these T&Cs at any time. Any changes will be communicated to users through the PICKUPXPRESS or via email.\n* Continued use of the Wallet after changes to these T&Cs will constitute acceptance of the modified terms."
                    },
                    {
                      title: "10. Governing Law",
                      content: "* Any disputes arising out of or related to these T&Cs will be subject to the exclusive jurisdiction of the courts of Gautam Budh Nagar/India."
                    },
                    {
                      title: "11. Contact Information",
                      content: "If you have any questions or concerns regarding these T&Cs, please contact our support team at [support@pickupxpress.com]."
                    }
                  ].map((section, index) => (
                    <div key={index} className="group">
                      <div className="flex items-start gap-2 mb-1">
                        <div className={`w-1 h-1 rounded-full mt-1.5 ${isDarkMode ? 'bg-indigo-400' : 'bg-black'}`}></div>
                        <h3 className={`font-bold text-[10px] ${isDarkMode ? 'text-rose-400' : 'text-red-600'}`}>
                          {section.title}
                        </h3>
                      </div>
                      <div className={`ml-4 pl-2.5 border-l ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                        <p className={`font-medium text-[9px] leading-relaxed whitespace-pre-line ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                          {section.content}
                        </p>
                      </div>
                    </div>
                  ))}

                  {/* Payment Methods Section */}
                  <div className={`mt-3 p-3 border rounded-xl transition-colors duration-300 ${
                    isDarkMode 
                      ? 'border-gray-800 bg-[#0F172A]/50' 
                      : 'border-gray-200 bg-gray-50'
                  }`}>
                    <div className="flex items-center gap-1.5 mb-2">
                      <div className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-black'}`}></div>
                      <h3 className={`font-bold text-[10px] ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}>
                        Payment Methods Supported for PICKUPXPRESS Wallet Top-Up:
                      </h3>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div className={`p-2.5 rounded-lg border transition-colors duration-300 ${
                        isDarkMode 
                          ? 'bg-[#111827] border-gray-800' 
                          : 'bg-white border-gray-200'
                      }`}>
                        <h4 className={`font-semibold text-[9px] mb-0.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Credit/Debit Cards:</h4>
                        <ul className={`space-y-0.5 text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                          <li>• Visa</li>
                          <li>• MasterCard</li>
                          <li>• American Express</li>
                          <li>• Discover</li>
                        </ul>
                      </div>

                      <div className={`p-2.5 rounded-lg border transition-colors duration-300 ${
                        isDarkMode 
                          ? 'bg-[#111827] border-gray-800' 
                          : 'bg-white border-gray-200'
                      }`}>
                        <h4 className={`font-semibold text-[9px] mb-0.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Digital Wallets:</h4>
                        <ul className={`space-y-0.5 text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                          <li>• Paytm</li>
                          <li>• Google Pay</li>
                          <li>• PhonePe</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletRecharge;